import { PersonaCategoriaTipoModel } from "./persona-categoria/persona-categoria-tipo.model";

export class PersonaCategoriaModel {
  id: number = 0;
  codigo: string = '';
  acronimo: string = '';
  nombre: string = '';
  descripcion: string = '';
  tipoId: number = 0;
  tipo: PersonaCategoriaTipoModel = new PersonaCategoriaTipoModel();

  constructor() { }
}
